<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">Angle of Attack</h1>
<h2 class="center">A Gabe Wager Novel</h2>
<h3 class="center" style="margin-top:80px;">Rex Burns</h3>
<p class="center" style="margin-top:80px;"><span>A MysteriousPress.com</span></p>
<p class="center"><span>Open Road Integrated Media</span></p>
<p class="center"><span>Ebook</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?36285be7